export default __webpack_public_path__ + "img/icon-welcome@2x.1d2b23b19adccdee1d32e890ab56b602.jpg";